var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconTextractError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.21739H14.375C13.8227 6.21739 13.375 5.76968 13.375 5.21739V1M19 6.21739V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V3C1 1.89543 1.89543 1 3 1H13.375M19 6.21739L13.375 1M10 10.5V13.1739M10 14.913V15.1304M14.9776 15.6465L10.8622 7.25747C10.5027 6.52478 9.46433 6.50794 9.08133 7.2286L4.62296 15.6177C4.26899 16.2837 4.75173 17.087 5.50601 17.087H14.0798C14.8199 17.087 15.3035 16.311 14.9776 15.6465Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTextractError);
export default __webpack_public_path__ + "static/media/streamline-icon-textract-error.4fbf9e4f.svg";
export { ForwardRef as ReactComponent };